import { ResolveCatalogListDropPositionParams } from './catalogListDragAndDrop.types';

export const resolveCatalogListDropPosition = ({
  activeId,
  overId,
  side,
  itemIds,
}: ResolveCatalogListDropPositionParams): number | null => {
  const currentIndex = itemIds.indexOf(activeId);
  const remainingIds = itemIds.filter((itemId) => itemId !== activeId);
  const overIndex = remainingIds.indexOf(overId);

  if (currentIndex === -1 || overIndex === -1) {
    return null;
  }

  const position = side === 'before' ? overIndex : overIndex + 1;

  if (position === currentIndex) {
    return null;
  }

  return position;
};
